import getPayeService from '../../../api/envService'
import { RENVOIE_ENDPOINT } from '../../../api/endpoints'
import RenvoieResult, { RenvoieResultData } from '../../constants/RenvoieResult'
import { SET_RENVOIE_RESULTS } from '../../reducers/renvoie-reducer'

export function setRenvoieResults(renvoieResults) {
  return { type: SET_RENVOIE_RESULTS, value: renvoieResults }
}

export const getRenvoieResults = payload => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setRenvoieResults([])))
    .then(() => getPayeService().post(RENVOIE_ENDPOINT, payload))
    .then(data => data.map(d => buildRenvoiResult(d)))
    .then(renvoieResult => dispatch(setRenvoieResults(renvoieResult)))
    .catch(e => {
      console.log(e)
    })

function buildRenvoiResult(data) {
  return new RenvoieResult(
    data.id,
    data.data.map(d => new RenvoieResultData(d.component, d.id, d.value, d.data)),
    data.customData.map(customD => new RenvoieResultData(customD.component, customD.id, customD.value, customD.data)),
    data.doublons
  )
}
